import { render } from "./bone.vue?vue&type=template&id=0c6c909c&scoped=true"
import script from "./bone.vue?vue&type=script&lang=ts"
export * from "./bone.vue?vue&type=script&lang=ts"

import "./bone.vue?vue&type=style&index=0&id=0c6c909c&lang=less&scoped=true"
import "./bone.vue?vue&type=style&index=1&id=0c6c909c&lang=less"
script.render = render
script.__scopeId = "data-v-0c6c909c"

export default script